import React from 'react'

export const HeaderLayOut = () => {
    return (
        <div>HeaderTop</div>
    )
}
